



























































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

import { DateInput, toShortDate } from '@/common/datetime';
import { DailyReport } from '@/models/dailyReport.model';
import EditPageDailyReportInput from '@/pages/index/pages/edit/components/EditPageDailyReportInput.vue';
import { ConfigStore } from '@/store/config';
import { LocationStore } from '@/store/location';


@Component({
  components: {
    DateInput,
    EditPageDailyReportInput,
  },
})
export default class NewEntryPageForm extends Vue {
  @Prop() disabled!: boolean;
  @Prop() readonly!: boolean;
  @Prop() value!: DailyReport[];

  @LocationStore.Bind.State fuels!: LocationStore.State<'fuels'>;
  @ConfigStore.Bind.State processRolloverDate!: ConfigStore.State<'processRolloverDate'>;

  activeFuelId = -1;
  todaysDate = toShortDate(new Date());

  get isBeforeRollover() {
    return this.value &&
           this.value.length &&
           this.value[0].date.localeCompare(this.processRolloverDate) < 0;
  }

  get reportByFuelId() {
    return this.value.reduce((result, report) => {
      result[report.fuelId] = report;
      return result;
    }, {});
  }

  @Emit('input')
  setReportAtIndex(i: number, updatedReport: DailyReport) {
    return [
      ...this.value.slice(0, i),
      updatedReport,
      ...this.value.slice(i + 1),
    ];
  }

  get date() {
    return this.value.length && this.value[0].date;
  }

  @Emit('input')
  setDate(date: string) {
    return this.value.map(m => ({ ...m, date }));
  }

  setFocus(refName: string) {
    const ref = this.$refs[refName] as EditPageDailyReportInput[];
    if (Array.isArray(ref)) {
      ref[0].focus();
    }
  }

}
